<div>
    <div class="container">
        <!-- header -->
        <div class="header-sticky-container drop-shadow">
            <div class="headers-continer container-width" #mainContent>
                <div class="header">
                    <div
                        class="header-btn-container"
                        [ngClass]="customGroup ? 'custom-group' : ''"
                    >
                        <div class="header-title">
                            <div class="lock-option" *ngIf="customGroup">
                                <mat-icon
                                    class="lock-icon"
                                    svgIcon="{{ pageAccessIcon }}"
                                >
                                </mat-icon>
                                <div data-cy="custom-channel-group-access-label">
                                    {{
                                        pageAccessTypeTile.concat(
                                            ".",
                                            pageAccessType
                                        ) | translate
                                    }}
                                </div>
                            </div>
                            <span
                                data-cy="channel-group-title"
                                class="header-group-name"
                                >{{ title }}</span
                            >
                        </div>
                        <app-custom-page-right-buttons
                            class="left-buttons"
                            *ngIf="customGroup"
                            [usersAccess]="usersAccess"
                            (onShareButtonClick)="changeShareSettings($event)"
                            (onEditButtonClick)="onEdit($event)"
                            (onDeleteButtonClick)="onDelete($event)"
                        />
                    </div>

                    <app-custom-page-description [text]="description" />

                    <div class="header-back-btn-wrapper">
                        <span
                            data-cy="channel-group-back-button"
                            class="header-back-btn"
                            (click)="emitNavigateBack()"
                        >
                            <mat-icon svgIcon="arrow-left"></mat-icon>
                            <span>{{
                                "forms.channel.alarm.label.back" | translate
                            }}</span>
                        </span>
                    </div>

                    <app-filterbar
                        [filterOption]="filterOption"
                        [filterbarLabels]="[]"
                        [showSimpleFilter]="showSimpleFilter"
                        [simpleFilterLabel]="simpleFilterLabel"
                        (onFilterChange)="onFilterChange($event)"
                    ></app-filterbar>
                </div>
                <!-- Table Header -->
                <div class="channel-table-container channel-table-header">
                    <div class="channel-table">
                        <app-channel-table-header></app-channel-table-header>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="channel-table-container container-width">
            <div class="channel-table" #scrollContainer>
                <ng-container *ngIf="responsive.isXLarge()">
                    <div class="virtual-scroll-container">
                        <div class="virtual-scroll-content">
                            <ng-container
                                *ngFor="
                                    let channel of filtredChannels;
                                    let i = index
                                "
                            >
                                <app-channel-table-row
                                    class="virtual-scroll-item"
                                    [channel]="channel"
                                    [isSelectedChannel]="
                                        selectedChannel?.id === channel.id
                                    "
                                    (click)="emitChannelSelected(channel, i)"
                                    (onInitScroll)="handleInitScroll($event)"
                                ></app-channel-table-row>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!responsive.isXLarge()">
                    <div class="virtual-scroll-container">
                        <div class="virtual-scroll-content">
                            <ng-container
                                *ngFor="
                                    let channel of filtredChannels;
                                    let i = index
                                "
                            >
                                <app-channel-table-row-wrap
                                    #channelTableRowWrap
                                    class="virtual-scroll-item"
                                    [channel]="channel"
                                    [isSelectedChannel]="
                                        selectedChannel?.id === channel.id
                                    "
                                    (selectChannel)="
                                        emitChannelSelected(channel, i)
                                    "
                                    (onSubmit)="onSubmitEmit($event)"
                                    (onCloseClicked)="onCloseClicked()"
                                    (onAdvancedSettings)="
                                        onAdvancedSettingsEmit($event)
                                    "
                                    (onInitScroll)="handleInitScroll($event)"
                                    (onDeleteAlarm)="onDeleteEmit($event)"
                                ></app-channel-table-row-wrap>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div
    class="channel-indication"
    *ngIf="!responsive.isXLarge() && selectedChannel"
>
    <span class="highlighted-text caption-small">{{
        selectedChannel.opsData.tag
    }}</span>
</div>
<app-pop-up-notification
    #previewMessage
    [message]="'dlg.channels.custom-group.preview.msg'"
    [closeButton]="'dlg.channels.custom-group.preview.close'"
    [ngClass]="getPreviewMessageVisible() ? 'show' : ''"
></app-pop-up-notification>

<app-ops-alarm-to-top
    (onTopEmit)="onScrollToTop()"
    *ngIf="
        (responsive.isXSmall() || responsive.isHandsetLandscape()) &&
        isScrollBtnVisible()
    "
></app-ops-alarm-to-top>

<div *ngIf="shareSettingsOpened" class="share-settings-container">
    <div class="share-settings-wrapper">
        <app-page-share-settings
            [ngClass]="['share-settings', responsive.screenSize]"
            [isPublic]="publicAccess"
            [inViewPage]="true"
            [usersAccess]="usersAccess"
            (oncloseSettings)="changeShareSettings($event)"
            (onUpdateUsersAccess)="updateUsersAccess($event)"
            (onUpdatePageAccess)="updatePageAccess($event)"
        >
        </app-page-share-settings>
    </div>
</div>
